export default "__VITE_ASSET__CAtmwkLu__"